import { render } from "./ProductsViewerPage.vue?vue&type=template&id=1f8382e1&ts=true"
import script from "./ProductsViewerPage.vue?vue&type=script&lang=ts"
export * from "./ProductsViewerPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__